import { handleActions } from "redux-actions";
import cloneDeep from "lodash/fp/cloneDeep";

import { INITIAL_CONFIG_DATA } from "../constants";

import {
    cleanupInitialConfig,
    editConfig,
    editConfigError,
    editConfigSuccess,
    getConfigByID,
    getConfigByIDError,
    getConfigByIDSuccess,
    getNormalizers,
    getNormalizersError,
    getNormalizersSuccess,
    mergeConfigMessageDialog,
    setBlockSelectorDialog,
    setConfigMessageDialog,
    setDataNormalizersDialog,
    setDataSelectorDialog,
    setInitialConfig
} from "./actions";

const initialState = {
    initialConfig: cloneDeep(INITIAL_CONFIG_DATA),
    isLoading: false,
    commentDialog: { isOpen: false },
    normalizers: {
        isLoading: false,
        normalizersList: {},
        codes: []
    },
    templateBlockSelectorDialog: {
        index: null,
        isOpen: false
    },
    templateDataSelectorsDialog: {
        indexTemplate: null,
        indexBlock: null,
        isOpen: false
    },
    templateDataNormalizersDialog: {
        indexTemplate: null,
        indexBlock: null,
        indexSelectors: null,
        isOpen: false
    }
};

export const createEditConfigReducer = handleActions(
    {
        [cleanupInitialConfig]: (state) => ({
            ...state,
            initialConfig: cloneDeep(INITIAL_CONFIG_DATA)
        }),

        [setConfigMessageDialog]: (state, { payload }) => ({
            ...state,
            commentDialog: {
                ...initialState.commentDialog,
                ...payload
            }
        }),
        [mergeConfigMessageDialog]: (state, { payload }) => ({
            ...state,
            commentDialog: {
                ...state.commentDialog,
                ...payload
            }
        }),

        [getNormalizers]: (state, { payload }) => ({
            ...state,
            normalizers: {
                ...state.normalizers,
                ...payload,
                isLoading: true
            }
        }),
        [getNormalizersSuccess]: (state, { payload }) => ({
            ...state,
            normalizers: {
                ...state.normalizers,
                ...payload,
                isLoading: false
            }
        }),
        [getNormalizersError]: (state, { payload }) => ({
            ...state,
            normalizers: {
                ...state.normalizers,
                ...payload,
                isLoading: false
            }
        }),

        [setBlockSelectorDialog]: (state, { payload }) => ({
            ...state,
            templateBlockSelectorDialog: {
                ...initialState.templateBlockSelectorDialog,
                ...payload
            }
        }),
        [setDataSelectorDialog]: (state, { payload }) => ({
            ...state,
            templateDataSelectorsDialog: {
                ...initialState.templateDataSelectorsDialog,
                ...payload
            }
        }),
        [setDataNormalizersDialog]: (state, { payload }) => ({
            ...state,
            templateDataNormalizersDialog: {
                ...initialState.templateDataNormalizersDialog,
                ...payload
            }
        }),

        [setInitialConfig]: (state, { payload }) => ({
            ...state,
            initialConfig: payload
        }),

        [getConfigByID]: (state) => ({
            ...state,
            isLoading: true
        }),
        [getConfigByIDSuccess]: (state, { payload }) => ({
            ...state,
            initialConfig: payload,
            isLoading: false
        }),
        [getConfigByIDError]: (state) => ({
            ...state,
            isLoading: false
        }),

        [editConfig]: (state) => ({
            ...state,
            isLoading: true
        }),
        [editConfigSuccess]: (state) => ({
            ...state,
            isLoading: false
        }),
        [editConfigError]: (state) => ({
            ...state,
            isLoading: false
        })
    },
    initialState
);
